<template>
  <v-card>
    <v-card-title>
      Simulação Financiamento
    </v-card-title>
    <v-card-text v-show="showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <v-card-subtitle>
      Total de {{ total_financiamento }} Simulações
    </v-card-subtitle>
    <GraphicColumn
      v-if="!showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn")
  },

  data() {
    return {
      categories: [],
      total_financiamento: 0,
      titleY: "Simulações",
      titleX: "Empresa",
      showCard: true,
      chartSeries: [
        {
          name: "Financiamentos",
          color: "#CC152C",
          name: "Financiamentos",
          data: [],
          showInLegend: true
        },
        {
          name: "Percentual",
          data: [],
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}%",
            x: 5
          },
          tooltip: {
            valueSuffix: "%"
          }
        }
      ],
      date_init: "",
      date_end: "",
      isCompany: false,
      company: []
    };
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.init();
    }
  },
  methods: {
    async init() {
      var dataValue = [];
      var dataValueColumn = [];
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/simulacaoFinancimento");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          var t = [];
          this.total_financiamento = result.data[0].total_all;
          this.getEmpresas.forEach((e, c) => {
            t = [];
            t = result.data.filter(a => {
              return a.empresa == e.cnpj;
            });
            dataValue.push(t.length > 0 ? Number(t[0].total_simulado) : 0);
            dataValueColumn.push(t.length > 0 ? Number(t[0].percentual) : 0);
            dataCategorie.push(e.apelido);
          });
        })
        .catch(erro => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie, dataValueColumn).then(a => {
        this.showCard = false;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.chartSeries[1].data = dataValueColumn;
      });
    }
  },

  created() {
    this.showCard = true;
    this.init();
  }
};
</script>

<style lang="scss"></style>
